<template>
    <div id="app">
        <router-view></router-view>
        <Foot></Foot>
    </div>
</template>

<script>
    import Heading from './components/Header'
    import Foot from './components/Footer'
    export default {
        components: {
            Heading,
            Foot
        }
    }
</script>

<style lang="scss">
    @import "./assets/style/index.scss";

    html, body {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        background-color: #f2f2f2;
        font-family: "PingFang SC", "Microsoft YaHei"
    }
    a {
        text-decoration: none;
    }
    @media (min-width: 415px) {
        .m-nav {
            display: none;
        }
    }
    @media (max-width: 414px) {
        body {
            background-color: #fff;
        }
        .n-nav {
            display: block;
        }
        .header,
        .sidebar,
        .footer {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?e1a5fbe6